import { Button } from "shared/ui/button";
import { EventRegistrationModal } from "features";
import { EventRegistrationButton } from "features";
import { useModal } from "shared/ui/modal";
import InfoImg from "../assets/InfoImg.png";
import styles from "./EventInfoSection.module.scss";

export const EventInfoSection = () => {
  const {
    isModalOpen: isEventRegistrationModalOpen,
    open: openEventRegistrationModal,
    close: closeEventRegistrationModal,
    toggle: toggleEventRegistrationModal,
  } = useModal(false);

  return (
    <>
      <div className={styles.infoSection}>
        <div className={styles.infoBlock}>
          <div className={styles.infoBlock__topBlock}>
            <div>
              <Button variant="filledWhite" size="medium" disabled={true}>
                28 мая 2026 года
              </Button>
            </div>
            <p className={styles.infoBlock__title}>
              Научная программа конгресса
            </p>
            <ul className={styles.infoBlock__list}>
              <li>Посещение научной программы конгресса</li>
              <li>Вход в экспозону</li>
              <li>Рабочая тетрадь участника конгресса</li>
              <li>Обед, кофе-брейки</li>
              <li>Розыгрыш призов от партнеров конгресса</li>
            </ul>
          </div>
          <div className={styles.infoBlock__buttonBlock}>
            <div className={styles.infoBlock__button}>
              <EventRegistrationButton
                variant="primaryWhite"
                openModal={openEventRegistrationModal}
              />
            </div>
          </div>
        </div>
        <div className={styles.imageBlock}>
          <img src={InfoImg} className={styles.imageBlock__img} alt="InfoImg" />
        </div>
      </div>
      <EventRegistrationModal
        isModalOpen={isEventRegistrationModalOpen}
        open={openEventRegistrationModal}
        close={closeEventRegistrationModal}
        toggle={toggleEventRegistrationModal}
      />
    </>
  );
};
